function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8333 15.5H26.3125C30.282 15.5 33.5 18.4101 33.5 22C33.5 25.5899 30.282 28.5 26.3125 28.5H23.9167M18.1667 28.5H17.6875C13.718 28.5 10.5 25.5899 10.5 22C10.5 18.4101 13.718 15.5 17.6875 15.5H20.0833",
  stroke: "currentcolor",
  strokeWidth: 3,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6586 11.7418L22.1414 15.259C22.0633 15.3371 22.0633 15.4637 22.1414 15.5418L25.6586 19.059C25.7846 19.185 26 19.0957 26 18.9175V11.8832C26 11.7051 25.7846 11.6158 25.6586 11.7418Z",
  fill: "currentcolor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3414 24.941L21.8586 28.4582C21.9367 28.5363 21.9367 28.6629 21.8586 28.741L18.3414 32.2582C18.2154 32.3842 18 32.2949 18 32.1168V25.0825C18 24.9043 18.2154 24.815 18.3414 24.941Z",
  fill: "currentcolor"
});

var SvgLoop = function SvgLoop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loop.39fd0c2c.svg";
export { ForwardRef as ReactComponent };